import React from "react";
import LoginView from "components/login";

const Login = () => <LoginView />;

export default Login;
